import styled from 'styled-components';

import breakpoints, { under } from '@polyai/ui/styles/config/breakpoints';
import themeColors from '@polyai/ui/styles/config/colors';
import sizes from '@polyai/ui/styles/config/sizes';
import themeSpacing from '@polyai/ui/styles/config/spacing';
import text from '@polyai/ui/styles/config/text';

export const RightPanel = styled.div`
  display: grid;
  place-items: start center;
  padding: ${themeSpacing.lg3};
  background: ${themeColors.background};

  @media ${under(breakpoints.sm)} {
    padding: ${themeSpacing.sm2};
  }
`;

export const ContentContainer = styled.div`
  display: grid;
  flex: 1;
  place-items: center center;

  width: 100%;
  max-width: ${sizes.wizardContentWidth}px;
  margin: 0 auto;
  padding: 2rem 0;
`;

export const Form = styled.div`
  display: grid;
  gap: ${themeSpacing.sm2};
  width: 100%;
  max-width: ${sizes.wizardContentWidth}px;
`;

export const Title = styled.h2`
  margin: 0 0 ${themeSpacing.sm2};
  font-size: ${text.size.header.large};
  font-weight: ${text.weight.semibold};
  color: ${themeColors.textPrimary};
`;

export const TermsLabel = styled.label`
  display: flex;
  gap: ${themeSpacing.xs2};
  align-items: flex-start;

  font-size: ${text.size.body.small};
  color: ${themeColors.textHelper};

  a {
    color: inherit;
    text-decoration: underline;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: ${themeSpacing.xs3};
  align-items: center;
  margin-top: ${themeSpacing.xs2};
`;

export const Logo = styled.img`
  position: absolute;
  top: ${themeSpacing.sm3};
  left: ${themeSpacing.sm3};

  width: auto;
  height: 28px;
`;
